import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tj3",
  "use": "icon-tj3-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tj3\"><path d=\"M739.4 676.8l24.7-43.7 38.5 22.9-24.5 43.7-38.7-22.9zM675 638.6l24.7-43.7 38.5 22.9-24.5 43.7-38.7-22.9z m-128.5-76.4l24.5-43.7 38.5 22.9-24.5 43.7-38.5-22.9z m64.2 38.2l24.7-43.7 38.5 22.9-24.5 43.7-38.7-22.9z m-99-503.8L161.6 304.5v415.8l350.2 207.9L862 720.3V304.5L511.7 96.6z m-24.5 758.8L210.6 691.2V362.8L487.2 527v328.4z m24.5-372.1L235.1 319.1l276.7-164.2 276.7 164.2-276.8 164.2z m24.5 372.1V527l276.7-164.2v328.4L536.2 855.4z m-122.3-314l38.5-22.9 24.5 43.7-38.5 22.9-24.5-43.7zM220.8 656.1l38.5-22.9 24.5 43.7-38.5 22.9-24.5-43.7z m128.7-76.5l38.5-22.9 24.5 43.7-38.5 22.9-24.5-43.7z m-64.3 38.2l38.5-22.9 24.5 43.7-38.5 22.9-24.5-43.7z m202-283.4h49v45.8h-49v-45.8z m0 76.4h49v45.8h-49v-45.8z m0-152.8h49v45.8h-49V258z m0-76.4h49v45.8h-49v-45.8z\" p-id=\"4541\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-tj3.svg
// module id = hUwO
// module chunks = 177